import { render, staticRenderFns } from "./text-blocks.page.vue?vue&type=template&id=64a023b9&scoped=true&"
import script from "./text-blocks.page.vue?vue&type=script&lang=js&"
export * from "./text-blocks.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a023b9",
  null
  
)

export default component.exports